"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _pick = require("./pick");

var _utils = require("./utils");

/**
 * Pick Variant is used to create theme-specific css.
 *
 * This example selects an appropriate variable for the current theme.
 * ```
 * import { pickVariant } from '@splunk/themes';
 *
 * ...
 *
 * const Wrapper = styled.div`
 *      ${pickVariant('appearance', {
 *          filled: 'background: red',
 *          open: 'border: 1px solid red',
 *      })}
 * `;
 * ```
 * This example selects an appropriate block of css for the current theme.
 * ```
 *  const Wrapper = styled.div`
 *      ${pickVariant('appearance', {
 *          filled: {
 *              enterprise: 'background: green',
 *              prisma: 'background: blue',
 *          },
 *          open: {
 *              enterprise: 'border: 1px solid green',
 *              prisma: 'border: 1px solid blue',
 *          },
 *      })}
 * `;
 * ```
 * @param {string} propName - The prop name used to resolve the variants. The prop value must be a `string` or `boolean`.
 * @param {object} themeOptions - An object consisting of a tree of theme options, with the prop variants the top of the tree and optional
 * theme variants below (`enterprise|prisma`, `light|dark`, or `compact|comfortable`).
 * @returns {function} The returned function is called by `styled-components`, which provides the props and theme context.
 * @public
 */
var pickVariant = function pickVariant(propName, tree) {
  return function (props) {
    var _props$theme;

    // TS: must assume prop value can be used as string key
    var variantKey = props[propName];
    var subTree = tree[variantKey];

    if ((0, _pick.isInterpolationResult)(subTree)) {
      return subTree;
    }

    var theme = (0, _utils.addThemeDefaults)((_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.splunkThemeV1);
    return (0, _pick.getThemeVariant)(subTree, theme);
  };
};

var _default = pickVariant;
exports["default"] = _default;